module.exports = __webpack_public_path__ + "media/images/ln-img1-2dc8908508aa5c7561b23f0a4f837610.png";